export class StringPatterns {
  static pincode: RegExp = /^[1-9]{1}[0-9]{2}\s{0,1}[0-9]{3}$/;

  static numberOnly: RegExp = /^\d+$/;

  static floatOnly: RegExp = /^([0-9]*[.])?[0-9]+$/;

  static firstName: RegExp = /^[a-zA-Z\s]{1,30}$/;

  static indianBankAccountNumber: RegExp = /^\d{9,18}$/;
}

export const phoneRegex = /^[6-9][0-9]{9}$/;
export const pinCodeRegex = /^[1-9][0-9]{5}$/;
export const multiplesOfHundred = /^[1-9]+[0-9]*00$/;
export const decimalAndIntegers = /\/^[-+]?[0-9]*.?[0-9]+([eE][-+]?[0-9]+)?$\//;
/* eslint-disable no-useless-escape */
export const emailPattern = /\b[\w\.-]+@[\w\.-]+\.\w{2,4}\b/;
/* eslint-disable no-useless-escape */
export const addressPattern = /^[a-zA-Z0-9\s\-\/.,]+$/;
export const safeInputPattern = /[a-zA-Z]/;
export const alphaPattern = /[a-zA-Z]/;
export const pincodePattern = /^[1-9]{1}[0-9]{2}\s{0,1}[0-9]{3}$/;
export const textPattern = /^(?! )[A-Za-z ]+(?<! )$/;
export const AlphaRegex = /^[A-Za-z\s]*$/;
export const dateRegex =
  /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/;

export const PanCardValidationRegex = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
export const upiRegex: RegExp = /[a-zA-Z0-9.\-_]{2,256}@[a-zA-Z]{2,64}/;
export const NcdDpIdRegex = /^IN\d{6}$/;

// 10 characters
// export const EmployeeCode = /^[0-9]+/; // /^MP[0-9]+/;
// F + 5 digits for branch code
// export const BranchCode = /^F[0-9]+/;

// Branch code - F followed by 3/4 characters ( length limit of 5 )
export const BranchCode = /^F.{3,4}$/;
// Employee code - MP – followed by 8 characters
export const EmployeeCode = /^MP.{8}$/;

export const reXSRF = /X-XSRF-TOKEN/;
